import type { MappingAttribute, MappingConfiguration } from '../../types';

const normalizePcfAttributeKey = (value: string): string =>
  value.trim().toUpperCase().replace(/[\s_-]/g, '');

const GENERAL_ATTRIBUTE_KEYS = new Set(
  [
    'OBJECT-TYPE',
    'SKEY',
    'PIPING-SPEC',
    'SYSTEM-GROUPING',
    'INSULATION-SPEC',
    'TRACING-SPEC',
    'WEIGHT',
    'INSULATIONTHICKNESS',
    'BoltBaseFamily',
  ].map(normalizePcfAttributeKey)
);

export const isGeneralAttributeMappedOutsideAll = (attributeName: string): boolean =>
  GENERAL_ATTRIBUTE_KEYS.has(normalizePcfAttributeKey(attributeName));

export const sanitizeAllObjectTypeAttributes = (
  attributes: MappingAttribute[]
): MappingAttribute[] => attributes.filter(
  (attribute) => !isGeneralAttributeMappedOutsideAll(attribute.pcfAttributeName ?? '')
);

export const sanitizeMappingConfiguration = (
  mappingConfiguration: MappingConfiguration
): MappingConfiguration => {
  const objectTypes = mappingConfiguration.general.mappingTable.objectType;
  const allObjectTypeIndex = objectTypes.findIndex((objectType) => objectType.name === 'ALL');

  if (allObjectTypeIndex === -1) {
    return mappingConfiguration;
  }

  const allObjectType = objectTypes[allObjectTypeIndex];
  const sanitizedAttributes = sanitizeAllObjectTypeAttributes(allObjectType.attributes || []);

  if (sanitizedAttributes.length === allObjectType.attributes.length) {
    return mappingConfiguration;
  }

  const nextObjectTypes = [...objectTypes];
  nextObjectTypes[allObjectTypeIndex] = {
    ...allObjectType,
    attributes: sanitizedAttributes,
  };

  return {
    ...mappingConfiguration,
    general: {
      ...mappingConfiguration.general,
      mappingTable: {
        ...mappingConfiguration.general.mappingTable,
        objectType: nextObjectTypes,
      },
    },
  };
};
